import { SetRecorder } from "./recorder";

let _mediaStream = null;

export async function startRecording(setRecorderState: SetRecorder) {
  console.log('🎙️ [HANDLER] startRecording called');
  console.log('🎙️ [HANDLER] Platform:', window.navigator.platform);
  console.log('🎙️ [HANDLER] User Agent:', window.navigator.userAgent);

  try {
    // CRITICAL: Clean up previous media stream to fix iOS reuse issue
    if (_mediaStream) {
      console.log('🧹 [HANDLER] Cleaning up previous media stream...');
      _mediaStream.getTracks().forEach(track => {
        console.log('🛑 [HANDLER] Stopping track:', track.label);
        track.stop();
      });
      _mediaStream = null;
    }

    console.log('🎙️ [HANDLER] Requesting microphone permission...');
    const stream: MediaStream = await navigator.mediaDevices.getUserMedia({
      audio: true,
    });

    console.log('✅ [HANDLER] Microphone permission granted!');
    console.log('🎙️ [HANDLER] Stream tracks:', stream.getTracks().length);
    stream.getTracks().forEach((track, index) => {
      console.log(`🎙️ [HANDLER] Track ${index}:`, {
        kind: track.kind,
        label: track.label,
        enabled: track.enabled,
        muted: track.muted,
        readyState: track.readyState
      });
    });

    _mediaStream = stream;
    console.log('✅ [HANDLER] Media stream stored in module variable');

    setRecorderState((prevState) => {
      console.log('🎙️ [HANDLER] Setting recorder state with new stream');
      return {
        ...prevState,
        initRecording: true,
        mediaStream: stream,
      };
    });
  } catch (err) {
    console.error('❌ [HANDLER] Error starting recording:', err);
    console.error('❌ [HANDLER] Error name:', err.name);
    console.error('❌ [HANDLER] Error message:', err.message);
  }
}

export function saveRecording(recorder: any) {
  console.log('💾 [HANDLER] saveRecording called');
  console.log('💾 [HANDLER] Recorder exists:', !!recorder);
  console.log('💾 [HANDLER] Recorder state:', recorder?.state);

  if (recorder && recorder.state !== "inactive") {
    console.log('⏹️ [HANDLER] Stopping recorder (state was:', recorder.state, ')');
    recorder.stop();
    console.log('⏹️ [HANDLER] Recorder.stop() called');
  } else {
    console.log('⚠️ [HANDLER] Cannot stop - Recorder is null or already inactive');
    if (!recorder) {
      console.log('⚠️ [HANDLER] Recorder is null/undefined');
    } else {
      console.log('⚠️ [HANDLER] Recorder state is already inactive');
    }
  }
}
